import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';

import { TIME_WAITING_LIST } from '../constants';

export default compose(
  withRouter,
  withProps(props => ({
    timeWaitingList: props.params.reservationTime === TIME_WAITING_LIST,
  })),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithTimeWaitingList.js